import {
    BaseSearcherState,
    initialBaseSearcherState
} from '@/components/common/searcher/components/base/base-searcher.model'
import { Nullable } from '@/shared/types/app.types'

export interface CustomIdentifierSearcherRequestParams<I> {
    id: string
    customIdentifier: Nullable<I>
}

export interface CustomIdentifierSearcherState<I> extends BaseSearcherState {
    customIdentifiers: I[]
    customIdentifier: Nullable<I>

    id: string
}
export const initialCustomIdentifierSearcherState =
    <I>(): CustomIdentifierSearcherState<I> => ({
        ...initialBaseSearcherState(),

        customIdentifiers: [],
        customIdentifier: null,

        id: ''
    })
